var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgNoteEmail = function SvgNoteEmail(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    "data-width-20": 16,
    "data-width-24": 19,
    viewBox: "0 0 15.7 11.7",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeWidth: 1.2,
    d: "M14.6 3.46V2.1A1.5 1.5 0 0 0 13.1.6h-11A1.5 1.5 0 0 0 .6 2.1v7a1.5 1.5 0 0 0 1.5 1.5h5.063"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeWidth: 1.2,
    d: "m1.1 1.1 6.386 4.421a.2.2 0 0 0 .228 0L14.1 1.1"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M8.7 11.54a.33.33 0 0 0 .233.097h.04l1.791-.273a.34.34 0 0 0 .19-.097l3.732-3.733a.33.33 0 0 0 .143-.143l.481-.481a.99.99 0 0 0 0-1.4l-.62-.62a.99.99 0 0 0-1.4 0L8.933 9.247a.34.34 0 0 0-.097.189l-.233 1.826a.32.32 0 0 0 .097.278m5.843-4.76.301-.302a.33.33 0 0 0 0-.466l-.62-.638a.33.33 0 0 0-.467 0l-.311.31zm-1.564-.631L9.46 9.652l-.162 1.25 1.267-.146 3.51-3.51z",
    clipRule: "evenodd"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgNoteEmail);
export default ForwardRef;